var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_2626"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "swm icon pack / inbox",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "swm icon pack / inbox",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_2626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 12L8.5 12L10 15L14 15L16 12L21 12",
    stroke: "#7A5CE0",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 12L18.24 4.64C18.09 4.25 17.72 4 17.3 4L6.69 4C6.27 4 5.9 4.25 5.75 4.64L3 12L3 18C3 19.1 3.89 20 5 20L19 20C20.1 20 21 19.1 21 18L21 12Z",
    stroke: "#7A5CE0",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publishIcon.45dab76400a8b9590840fc15f3c84aa3.svg";
export { ForwardRef as ReactComponent };